module.exports = __webpack_public_path__ + "images/131_4096.jpg";